import {
  Layer,
  BillboardRenderer,
  BillboardImage,
  BillboardImageRef,
  text2imageData,
  View,
} from "@hscmap/stellar-globe";
import { LayerComponentBase } from "./layer_component_base";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

export type V3 = [number, number, number]
export interface IBillboardText {
  text: string,
  position: V3,
  font?: string,
  color?: string,
}

class TextLayer extends Layer {
  private renderer!: BillboardRenderer

  constructor(
    public billboardTexts: IBillboardText[],
    public defaultFont: string,
    public defaultColor: string,
    public alpha = 1,
  ) {
    super()
  }

  rebuild() {
    const images: BillboardImage[] = []
    const imageRefs: BillboardImageRef[] = []
    for (const bt of this.billboardTexts) {
      imageRefs.push({
        imageID: images.length,
        position: bt.position,
      })
      images.push({
        imageData: text2imageData(bt.text, bt.font || this.defaultFont, bt.color || this.defaultColor),
        origin: [0, 0],
      })
    }
    this.renderer.buildArray(images, imageRefs)
    this.globe.requestRefresh()
  }

  onAdd() {
    this.renderer = new BillboardRenderer(this.globe.gl)
    this.rebuild()
  }

  onRemove() {
    this.renderer.release()
  }

  setAlpha(alpha: number) {
    this.alpha = alpha
    this.globe.requestRefresh()
  }

  render(view: View) {
    const alpha = this.alpha * Layer.overlayAlpha(view)
    this.renderer.alpha = alpha
    this.renderer.render(view)
  }
}

@Component
export default class TextLayerComponent extends LayerComponentBase<TextLayer> {
  @Prop({ required: true })
  text!: IBillboardText[]

  @Watch('text')
  onTextsChange() {
    this.layer.billboardTexts = this.text
    this.layer.rebuild()
  }

  @Prop({ default: '#fff' })
  defaultColor!: string

  @Prop({ default: '18px sans-serif' })
  defaultFont!: string

  @Prop({ default: 1 })
  alpha!: number
  @Watch('alpha')
  onAlphaChange() {
    this.layer.setAlpha(this.alpha)
  }

  newLayer() {
    return new TextLayer(this.text, this.defaultFont, this.defaultColor, this.alpha)
  }
}
